<app-widget
    #widget
    *ngIf="metric === MetricsEnum.VIRTUALSERVICES"
    class="widget-item col-span-2"
    title="{{ 'frontends' | myLbTranslate }}"
    id="widget-virtual-services"
    [loading]="loading && apiLoading"
    [state]="state"
    [hasPermissions]="permissionsLookup['virtual-services-manage-services']"
    (showContent)="getWidgetDetails($event)">
    <div *ngIf="scrolled" class="scroll-close-button" (click)="scrolled = !scrolled">
        <img ngSrc="assets/shared/icons/close-cross.svg" alt="Close icon" height="20" width="20"/>
    </div>
    <div class="content-vertical-full-width">
        <div *ngIf="!scrolled">
            <div class="status-head" title="{{ 'online' | myLbTranslate}}">
                <a
                    class="success"
                    [class.disabled]="!permissionsLookup['virtual-services-manage-services']"
                    (click)="navigateToManageServicesPage(onlineStatus)">{{ online }}</a>
            </div>
            <div class="spacer">&middot;</div>
            <div class="status-head" title="{{ 'maintenance' | myLbTranslate }}">
                <a
                    class="maintenance"
                    [class.disabled]="!permissionsLookup['virtual-services-manage-services']"
                    (click)="navigateToManageServicesPage(maintStatus)">{{ maint }}</a>
            </div>
            <div class="spacer">&middot;</div>
            <div class="status-head" title="{{ 'failure' | myLbTranslate }}">
                <a
                    class="critical"
                    [class.disabled]="!permissionsLookup['virtual-services-manage-services']"
                    (click)="navigateToManageServicesPage(downStatus)">{{ failure }}</a>
            </div>
            <h2 class="widget-description">{{ 'virtual_service_widget_frontend_overview' | myLbTranslate }}</h2>
        </div>
        <div #list id="service-list" class="expandable-list" [class.extended]="scrolled">
            <table class="widget-table">
                <tr class="table-headers">
                    <th></th>
                    <th class="services">{{ 'service' | myLbTranslate }}</th>
                    <th>{{ 'ip' | myLbTranslate }}</th>
                    <th>{{ 'conn' | myLbTranslate }}</th>
                    <th>{{ 'ports' | myLbTranslate }}</th>
                    <th>{{ 'type' | myLbTranslate }}</th>
                </tr>
                <tr
                    *ngFor="let row of serviceData"
                    class="row-content"
                    [class.disabled]="!permissionsLookup['virtual-services-service-details']"
                    (click)="navigateToServiceDetailsPage(row)">
                    <td>
                        <div *ngIf="row.SSLEnable">
                            <app-tooltip
                                width="60"
                                trigger="<span class='padlock'></span>">
                                {{ 'ssl' | myLbTranslate }}
                            </app-tooltip>
                        </div>
                    </td>
                    <td>{{ row.label | truncate:[20] }}</td>
                    <td>{{ row.fip }}</td>
                    <td>{{ row.sessions }}</td>
                    <td>{{ row.ports }}</td>
                    <td>{{ row.templateTypeFriendlyName }}</td>
                </tr>
            </table>
        </div>
    </div>
</app-widget>

<app-widget
    #widget
    *ngIf="metric === MetricsEnum.CONNECTIONS"
    [title]="metric"
    [state]="state"
    [id]="'widget-virtual-services-connections'"
    [loading]="loading"
    (showContent)="getWidgetDetails(true)">
    <div class="content-vertical-middle">
        <h1>{{ totalConnections }}</h1>
    </div>
    <div *ngIf="totalConnections" class="dot-traffic-wrapper">
        <span *ngIf="totalConnections > 0" class="animation-dot-traffic">
            <span class="anim-helper-1"></span>
            <span *ngIf="totalConnections >= 100" class="anim-helper-2"></span>
            <span *ngIf="totalConnections >= 1000" class="anim-helper-3"></span>
        </span>
    </div>
</app-widget>
